import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "page" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "" }, [
  /*#__PURE__*/_createElementVNode("h1", null, [
    /*#__PURE__*/_createTextVNode(" Automations "),
    /*#__PURE__*/_createElementVNode("div", {
      class: "btn btn-primary me-4",
      "data-bs-toggle": "modal",
      "data-bs-target": "#AddFlowModal"
    }, " Add ")
  ])
], -1)
const _hoisted_3 = { class: "card" }
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = {
  key: 1,
  class: "table table-hover"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("thead", { class: "" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Name")
    ]),
    /*#__PURE__*/_createElementVNode("th", { scope: "col" }, [
      /*#__PURE__*/_createElementVNode("b", null, "Updated By")
    ]),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end"
    }, [
      /*#__PURE__*/_createElementVNode("b", null, "Actions")
    ])
  ])
], -1)
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "text-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_loading_spinner = _resolveComponent("loading-spinner")!
  const _component_context_menu = _resolveComponent("context-menu")!
  const _component_AddFlowModal = _resolveComponent("AddFlowModal")!
  const _component_DeleteFlowModal = _resolveComponent("DeleteFlowModal")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_ctx.loading)
            ? (_openBlock(), _createBlock(_component_loading_spinner, { key: 0 }))
            : _createCommentVNode("", true),
          (!_ctx.loading)
            ? (_openBlock(), _createElementBlock("table", _hoisted_5, [
                _hoisted_6,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.flows, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      class: _normalizeClass(["cursor-pointer", { odd: index }]),
                      key: item.flowId
                    }, [
                      _createElementVNode("td", {
                        onClick: ($event: any) => (_ctx.go(item.flowId))
                      }, _toDisplayString(item.name), 9, _hoisted_7),
                      _createElementVNode("td", {
                        onClick: ($event: any) => (_ctx.go(item.flowId))
                      }, _toDisplayString(item.btime), 9, _hoisted_8),
                      _createElementVNode("td", _hoisted_9, [
                        _createVNode(_component_context_menu, {
                          onClick: _withModifiers(($event: any) => (_ctx.selectedItemId = item.typeId), ["stop"]),
                          id: index,
                          links: [
                        {
                          text: 'Delete',
                          icon: 'trash-2',
                          bsTarget: '#DeleteFlowModal',
                        },
                      ]
                        }, null, 8, ["onClick", "id"])
                      ])
                    ], 2))
                  }), 128))
                ])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_AddFlowModal, {
        onReload: _ctx.load,
        onAdded: _cache[0] || (_cache[0] = ($event: any) => (_ctx.go($event)))
      }, null, 8, ["onReload"]),
      _createVNode(_component_DeleteFlowModal, {
        onReload: _ctx.load,
        typeId: _ctx.selectedItemId
      }, null, 8, ["onReload", "typeId"])
    ])
  ]))
}